import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import successImg from "../../assets/images/userprofile/successImg.png";
import { useFormik } from "formik";
import * as Yup from "yup";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper",
  border: "1px solid white",
  boxShadow: 24,
  pt: 2,
  px: 0,
  pb: 3,
};

//Validation Schema
const familySchema = Yup.object().shape({
  father_name: Yup.string().required("Father name is required"),
  mother_name: Yup.string().required("Mother name is required"),
  father_occupation: Yup.string().required("Father occupation is required"),
  mother_occupation: Yup.string().required("Mother occupation is required"),
  total_brothers: Yup.number().required("Total brothers is required"),
  total_sisters: Yup.number().required("Total sisters is required"),
  total_brothers_married: Yup.number().required("Brothers married is required"),
  total_sisters_married: Yup.number().required("Sisters married is required"),
  family_type: Yup.string().required("Family type is required"),
  family_style: Yup.string().required("Family style is required"),
  //   mother_is_alive: Yup.boolean().oneOf(
  //   [true],
  //   "Please confirm if mother is alive"
  // ),
  // father_is_alive: Yup.boolean().oneOf(
  //   [true],
  //   "Please confirm if father is alive"
  // ),
});

export function FamilyInfo({ id }) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const formik = useFormik({
    initialValues: {
      father_name: "",
      mother_name: "",
      father_occupation: "",
      mother_occupation: "",
      total_brothers: "",
      total_sisters: "",
      total_brothers_married: "",
      total_sisters_married: "",
      family_type: "",
      family_style: "",
      mother_is_alive: false,
      father_is_alive: false,
    },
    validationSchema: familySchema,
    onSubmit: async (values) => {
      try {
        const dataToSave = {
          profile: {
            father_name: values.father_name,
            mother_name: values.mother_name,
            father_occupation: values.father_occupation,
            mother_occupation: values.mother_occupation,
            total_brothers: values.total_brothers,
            total_sisters: values.total_sisters,
            total_brothers_married: values.total_brothers_married,
            total_sisters_married: values.total_sisters_married,
            mother_is_alive: values.mother_is_alive,
            father_is_alive: values.father_is_alive,
            family_type: Number(values.family_type),
            family_style: Number(values.family_style),
          },
        };
        localStorage.setItem("familyDetails", JSON.stringify(dataToSave));
        handleOpen();
         setTimeout(() => {
            handleClose();
          },2000);
      } catch (error) {
        console.error("Error saving to localStorage:", error);
      }
    },
  });

  // get and set form data from localStorage to fields
  // useEffect(() => {
  //   const familyDetails = localStorage.getItem("familyDetails");
  //   if (familyDetails) {
  //     try {
  //       const parsedData = JSON.parse(familyDetails);
  //       formik.setValues(parsedData);
  //     } catch (err) {
  //       console.error("Error parsing saved data:", err);
  //     }
  //   }
  // }, []);

  useEffect(() => {
  const savedData = localStorage.getItem("familyDetails");
  if (savedData) {
    const parsed = JSON.parse(savedData);

    formik.setValues({
      ...formik.initialValues,

      father_name: parsed.profile?.father_name || "",
      mother_name: parsed.profile?.mother_name || "",
      father_occupation: parsed.profile?.father_occupation || "",
      mother_occupation: parsed.profile?.mother_occupation || "",

      total_brothers:
        parsed.profile?.total_brothers !== undefined && parsed.profile?.total_brothers !== null
          ? String(parsed.profile.total_brothers)
          : "",
      total_sisters:
        parsed.profile?.total_sisters !== undefined && parsed.profile?.total_sisters !== null
          ? String(parsed.profile.total_sisters)
          : "",
      total_brothers_married:
        parsed.profile?.total_brothers_married !== undefined && parsed.profile?.total_brothers_married !== null
          ? String(parsed.profile.total_brothers_married)
          : "",
      total_sisters_married:
        parsed.profile?.total_sisters_married !== undefined && parsed.profile?.total_sisters_married !== null
          ? String(parsed.profile.total_sisters_married)
          : "",

      family_type:
        parsed.profile?.family_type !== undefined && parsed.profile?.family_type !== null
          ? String(parsed.profile.family_type)
          : "",
      family_style:
        parsed.profile?.family_style !== undefined && parsed.profile?.family_style !== null
          ? String(parsed.profile.family_style)
          : "",

      mother_is_alive: !!parsed.profile?.mother_is_alive,
      father_is_alive: !!parsed.profile?.father_is_alive
    });
  }
}, []);

  return (
    <form onSubmit={formik.handleSubmit}>
      <div>
        {/* row1 */}
        <div className="family-subcontainer">
          <div>
            <div className="family-label">
              Father Name <span className="text-danger">*</span>
            </div>
            <div className="family-input">
              <input
                type="text"
                name="father_name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.father_name}
                placeholder="Enter Father Name"
              />
              {formik.touched.father_name && formik.errors.father_name && (
                <div className="text-danger">{formik.errors.father_name}</div>
              )}
            </div>
          </div>
          <div>
            <div className="family-label">
              Mother Name <span className="text-danger">*</span>
            </div>
            <div className="family-input">
              <input
                type="text"
                name="mother_name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.mother_name}
                placeholder="Enter Mother Name"
              />
              {formik.touched.mother_name && formik.errors.mother_name && (
                <div className="text-danger">{formik.errors.mother_name}</div>
              )}
            </div>
          </div>
        </div>

        {/* row2 */}
        <div className="family-subcontainer">
          <div>
            <div className="family-label">
              Father Occupation <span className="text-danger">*</span>
            </div>
            <div className="family-input">
              <input
                type="text"
                name="father_occupation"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.father_occupation}
                placeholder="Enter Father Occupation"
              />
              {formik.touched.father_occupation &&
                formik.errors.father_occupation && (
                  <div className="text-danger">
                    {formik.errors.father_occupation}
                  </div>
                )}
            </div>
          </div>
          <div>
            <div className="family-label">
              Mother Occupation <span className="text-danger">*</span>
            </div>
            <div className="family-input">
              <input
                type="text"
                name="mother_occupation"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.mother_occupation}
                placeholder="Enter Mother Occupation"
              />
              {formik.touched.mother_occupation &&
                formik.errors.mother_occupation && (
                  <div className="text-danger">
                    {formik.errors.mother_occupation}
                  </div>
                )}
            </div>
          </div>
        </div>

        {/* row3 */}
        <div className="family-subcontainer">
          <div>
            <div className="family-label">
              Total Brothers <span className="text-danger">*</span>
            </div>
            <div className="family-input">
              <input
                type="number"
                name="total_brothers"
                min="0"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.total_brothers}
              />
              {formik.touched.total_brothers &&
                formik.errors.total_brothers && (
                  <div className="text-danger">
                    {formik.errors.total_brothers}
                  </div>
                )}
            </div>
          </div>
          <div>
            <div className="family-label">
              Total Sisters <span className="text-danger">*</span>
            </div>
            <div className="family-input">
              <input
                type="number"
                min="0"
                name="total_sisters"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.total_sisters}
              />
              {formik.touched.total_sisters && formik.errors.total_sisters && (
                <div className="text-danger">{formik.errors.total_sisters}</div>
              )}
            </div>
          </div>
        </div>

        {/* row4 */}
        <div className="family-subcontainer">
          <div>
            <div className="family-label">
              Total Brothers Married <span className="text-danger">*</span>
            </div>
            <div className="family-input">
              <input
                type="number"
                min="0"
                name="total_brothers_married"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.total_brothers_married}
              />
              {formik.touched.total_brothers_married &&
                formik.errors.total_brothers_married && (
                  <div className="text-danger">
                    {formik.errors.total_brothers_married}
                  </div>
                )}
            </div>
          </div>
          <div>
            <div className="family-label">
              Total Sisters Married <span className="text-danger">*</span>
            </div>
            <div className="family-input">
              <input
                type="number"
                min="0"
                name="total_sisters_married"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.total_sisters_married}
              />
              {formik.touched.total_sisters_married &&
                formik.errors.total_sisters_married && (
                  <div className="text-danger">
                    {formik.errors.total_sisters_married}
                  </div>
                )}
            </div>
          </div>
        </div>

        {/* row5 */}
        <div className="family-subcontainer">
          <div>
            <div className="family-label">
              Family Type <span className="text-danger">*</span>
            </div>
            <select
              className="dropdown-btnFamily"
              name="family_type"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.family_type}
            >
              <option value="" selected disabled>
                Select
              </option>
              <option value="1">Nuclear Family</option>
              <option value="2">Joint Family</option>
              <option value="3">Single Parent Family</option>
              <option value="4">Extended Family</option>
              <option value="5">Blended Family</option>
              <option value="6">Adoptive Family</option>
              <option value="7">Other</option>
            </select>
            {formik.touched.family_type && formik.errors.family_type && (
              <div className="text-danger">{formik.errors.family_type}</div>
            )}
          </div>
          <div>
            <div className="family-label">
              Family Style <span className="text-danger">*</span>
            </div>
            <select
              className="dropdown-btnFamily"
              name="family_style"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.family_style}
            >
              <option value="" disabled selected>
                Select
              </option>
              <option value="1">South Indian</option>
              <option value="2">North Indian</option>
              <option value="3">Others</option>
            </select>
            {formik.touched.family_style && formik.errors.family_style && (
              <div className="text-danger">{formik.errors.family_style}</div>
            )}
          </div>
        </div>

        {/* row6 */}
        <div className="family-subcontainer">
          <div>
            <input
              type="checkbox"
              name="mother_is_alive"
              onChange={(e) =>
                formik.setFieldValue("mother_is_alive", e.target.checked)
              }
              checked={formik.values.mother_is_alive === true}
            />
            <label className="family-label">Mother is Alive</label>
            <div>
              {formik.touched.mother_is_alive &&
                formik.errors.mother_is_alive && (
                  <div className="text-danger">
                    {formik.errors.mother_is_alive}
                  </div>
                )}
            </div>
          </div>
          <div>
            <input
              type="checkbox"
              name="father_is_alive"
              onChange={(e) =>
                formik.setFieldValue("father_is_alive", e.target.checked)
              }
              checked={formik.values.father_is_alive === true}
            />
            <label className="family-label">Father is Alive</label>
            <div>
              {formik.touched.father_is_alive &&
                formik.errors.father_is_alive && (
                  <div className="text-danger">
                    {formik.errors.father_is_alive}
                  </div>
                )}
            </div>
          </div>
        </div>

        {/* Save Button */}
        <div className="btnBasicSave">
          <Button type="submit">Save Changes</Button>
        </div>

        {/* Modal */}
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
        >
          <Fade in={open}>
            <Box sx={style} className="modal-box">
              <img src={successImg} alt="success" />
              <Typography variant="h6" component="h2">
                Thank You
              </Typography>
             <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                   Family information saved successfully
              </Typography>
            </Box>
          </Fade>
        </Modal>
      </div>
    </form>
  );
}
